import { useContext } from "react";
import { MediaQueryContext } from "./provider";

export const useMedia = () => {
  const { isMobile } = useContext(MediaQueryContext);

  return { isMobile };
};
